import { getApp, getApps, initializeApp } from 'firebase/app';
import { browserLocalPersistence, getAuth, GoogleAuthProvider, setPersistence } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyAlWj3AeXa9c-ntZTNftl7O6YJSpgffVRY',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'digitalergastro.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'digitalergastro',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'digitalergastro.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '813394979839',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:813394979839:web:a7c566eba2c474b0f015ca',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-6E5NEBJT2C',
};

export const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);
export const googleAuthProvider = new GoogleAuthProvider();

googleAuthProvider.setCustomParameters({
  prompt: 'select_account',
});

setPersistence(firebaseAuth, browserLocalPersistence).catch(() => {
  // Persistence may be unavailable in private browsing or restricted environments.
});
